import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLaunchpad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M18.532 3.338a2.197 2.197 0 0 1 1.973 1.973l.284 2.904a4.092 4.092 0 0 1-1.179 3.292L9.62 21.499a.75.75 0 0 0 1.06 1.06l9.992-9.991a5.591 5.591 0 0 0 1.611-4.5l-.285-2.904a3.697 3.697 0 0 0-3.318-3.318l-2.904-.285a5.591 5.591 0 0 0-4.5 1.61l-7.014 7.016a.75.75 0 0 0 1.06 1.06l7.015-7.014a4.091 4.091 0 0 1 3.292-1.18l2.904.285Zm-3.909 3.37a1.67 1.67 0 1 1 2.363 2.362 1.67 1.67 0 0 1-2.363-2.362Zm3.424-1.061a3.17 3.17 0 1 0-4.484 4.484 3.17 3.17 0 0 0 4.484-4.484Z"
    />
    <path
      fill="#F7A600"
      d="M11.747 10.82a.75.75 0 1 0-1.06-1.061L4.9 15.545a.75.75 0 0 0 1.061 1.06l5.786-5.785Zm-.236 5.122a.75.75 0 0 0-1.06-1.06l-5.787 5.785a.75.75 0 1 0 1.06 1.061l5.787-5.786Z"
    />
  </svg>
);
export default SvgTwoColorLaunchpad;
